export const DELETE_ATTORNEY = "DELETE.ATTORNEY";
export const DELETE_CLIENT = "DELETE.CLIENT";
export const DELETE_JUDGE = "DELETE.JUDGE";
export const DELETE_LEAD = "DELETE.LEAD";
export const DELETE_STAFF = "DELETE.STAFF";
export const DELETE_VENDOR = "EDIT.PERSON";

export const EDIT_ATTORNEY = "EDIT.ATTORNEY";
export const EDIT_CLIENT = "EDIT.CLIENT";
export const EDIT_JUDGE = "EDIT.JUDGE";
export const EDIT_LEAD = "EDIT.LEAD";
export const EDIT_STAFF = "EDIT.STAFF"; 
export const EDIT_VENDOR = "EDIT.PERSON";
export const EDIT_PAYROLL = "EDIT.PAYROLL";
export const EDIT_CLOCK = "EDIT.CLOCK";
export const EDIT_EXPENSE = "EDIT.EXPENSE";
export const EDIT_PAYMENT = "EDIT.PAYMENT";
export const EDIT_INVOICE = "EDIT.INVOICE";
export const EDIT_MATTER = "EDIT.MATTER";
export const VIEW_AGREEMENT = "VIEW.AGREEMENT";
export const CREATE_AGREEMENT = "CREATE.AGREEMENT";
export const EDIT_AGREEMENT = "EDIT.AGREEMENT";
export const FINALIZE_AGREEMENT = "FINALIZE.AGREEMENT";
export const EXPORT_AGREEMENT = "EXPORT.AGREEMENT";
export const DELETE_AGREEMENT = "DELETE.AGREEMENT";
export const CUSTOMIZE_AGREEMENT_AI = "CUSTOMIZE.AGREEMENT.AI";
export const MANAGE_AGREEMENT_TYPE = "MANAGE.AGREEMENT.TYPE";
export const VIEW_AGREEMENT_PROVISION_LIBRARY = "VIEW.AGREEMENT.PROVISION.LIBRARY";
export const EDIT_AGREEMENT_PROVISION_LIBRARY = "EDIT.AGREEMENT.PROVISION.LIBRARY";
export const ADD_AGREEMENT_PROVISION_LIBRARY = "ADD.AGREEMENT.PROVISION.LIBRARY";
export const APPROVE_AGREEMENT_PROVISION_LIBRARY = "APPROVE.AGREEMENT.PROVISION.LIBRARY";
export const EDIT_CHECK = "EDIT.CHECK";
